import { Button, Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../context/GlobalContext';
import { useContext } from 'react';
import Modal from '../Modal/Modal';

import './AlertModal.scss';

interface Props {
    id?: string;
    rtl?: boolean;
    firstButtonText?: string;
    secondButtonText?: string;
    modalFirstButtonClick?: () => void;
    modalSecondButtonClick?: () => void;
    handleHeaderCancel?: () => void;
    title?: string;
    sub_desc?: string;
    description?: string;
}

function AlertModal({ rtl, id, handleHeaderCancel, title, description, firstButtonText, secondButtonText, modalFirstButtonClick, modalSecondButtonClick, sub_desc }: Props) {
    const { dispatch }: any = useContext(GlobalContext);

    const handleFirstClick = () => {
        dispatch({ type: 'UPDATE_PAGE', payload: 'TR_Login' })
        dispatch({ type: 'RESET_DATA' })
        if (modalFirstButtonClick) modalFirstButtonClick()
    }

    const handleSecondClick = () => {
        dispatch({ type: 'UPDATE_PAGE', payload: 'map' });
        dispatch({ type: 'UPDATE_POPUP', payload: '' })
        dispatch({ type: 'RESET_DATA' })
        if (modalSecondButtonClick) modalSecondButtonClick()
    }

    return (
        <Modal handleHeaderCancel={handleHeaderCancel} id={id} rtl={rtl} close={false} contentClassName='col-10 m-auto' className=''>
            <Typography rtl={rtl} className='Alert__title mb-2'>{title}</Typography>
            <Typography rtl={rtl} className='Alert__subtitle'>{description}</Typography>
            {sub_desc && <Typography rtl={rtl} className='Alert__subtitle'>{sub_desc}</Typography>}
            <Button rtl={rtl} className='Alert__Btn1' onClick={handleFirstClick}>{firstButtonText}</Button>
            {secondButtonText && <Button rtl={rtl} className='Alert__Btn2' onClick={handleSecondClick}>{secondButtonText}</Button>}
        </Modal>
    )
}

export default AlertModal